import Vue from 'vue';
import { fallbackLocale, locale } from './locale';

function getLocalDateString(date) {
  return new Date(date).toLocaleDateString(locale || fallbackLocale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

Vue.filter('Date', getLocalDateString);
